<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <side-bar :backgroundColor="colorBackground" id="sidebar">
      <mobile-menu></mobile-menu>
      <template v-if="menus.length > 0 && this.userLogged" v-slot:links>
        <sidebar-item
          :hideClassName="hideClassName"
          v-if="isMenuVisible('/cliente/envios')"
          :link="{
            name: 'Mis Envíos',
            icon: 'nc-icon nc-delivery-fast',
            path: '/cliente/envios',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :hideClassName="hideClassName"
          v-if="isMenuVisible('/cliente/rma')"
          :link="{
            name: 'RMA',
            icon: 'nc-icon nc-refresh-02',
            path: '/cliente/rma',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :hideClassName="hideClassName"
          v-if="isMenuVisible('/cliente/envios-agrupados')"
          :link="{
            name: 'Envíos agrupados',
            icon: 'nc-icon nc-layers-3',
            path: '/cliente/envios-agrupados',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/importaciones')"
          :hideClassName="hideClassName"
          :link="{
            name: 'Importaciones',
            icon: 'nc-icon nc-cloud-upload-94',
            path: '*',
          }"
        >
          <sidebar-item
            v-if="isMenuVisible('/cliente/importacion')"
            :hideClassName="hideClassName"
            :link="{
              name: 'Envíos',
              path: '/cliente/importacion',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="isMenuVisible('/cliente/ImportacionesRma')"
            :hideClassName="hideClassName"
            :link="{
              name: 'RMA',
              path: '/cliente/ImportacionesRma',
            }"
          >
          </sidebar-item>
        </sidebar-item>
        <sidebar-item
          :hideClassName="hideClassName"
          v-if="isMenuVisible('/cliente/incidencias')"
          :link="{
            name: 'Gestión de Incidencias',
            icon: 'nc-icon nc-settings-tool-66',
            path: '/cliente/incidencias',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :hideClassName="hideClassName"
          v-if="isMenuVisible('/cliente/facturas')"
          :link="{
            name: 'Facturas',
            icon: 'nc-icon nc-money-coins',
            path: '/cliente/facturas',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/logistica')"
          :hideClassName="hideClassName"
          :link="{
            name: 'Logística',
            icon: 'nc-icon nc-app',
            path: '*',
          }"
        >
          <sidebar-item
            v-if="isMenuVisible('/logistica/articulos')"
            :hideClassName="hideClassName"
            :link="{
              name: 'Artículos',
              path: '/logistica/articulos',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="isMenuVisible('/logistica/packs')"
            :hideClassName="hideClassName"
            :link="{
              name: 'Packs',
              path: '/logistica/packs',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="isMenuVisible('/logistica/ordenes-entrada')"
            :hideClassName="hideClassName"
            :link="{
              name: 'Ordenes entrada',
              path: '/logistica/ordenes-entrada',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="isMenuVisible('/logistica/ordenes-salida')"
            :hideClassName="hideClassName"
            :link="{
              name: 'Ordenes salida',
              path: '/logistica/ordenes-salida',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="isMenuVisible('/logistica/stock')"
            :hideClassName="hideClassName"
            :link="{
              name: 'Stock',
              path: '/logistica/stock',
            }"
          >
          </sidebar-item>
        </sidebar-item>
        <sidebar-item
          :hideClassName="hideClassName"
          v-if="isMenuVisible('/cliente/libretaContacto')"
          :link="{
            name: 'Libreta de Contactos',
            icon: 'nc-icon nc-badge',
            path: '/cliente/libretaContacto',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :hideClassName="hideClassName"
          v-if="isMenuVisible('/cliente/usuarios')"
          :link="{
            name: 'Usuarios',
            icon: 'nc-icon nc-single-02',
            path: '/cliente/usuarios',
          }"
        >
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  data() {
    return {
      hideClassName: "show-item",
      resizeObserver: null,
      colorBackground: "black",
      menus: [],
      userLogged: null,
    };
  },
  computed: {
    menusStatus() {
      return this.$store.state.roles.menus.status;
    },
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar("main-panel");

        docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
    onResize() {
      let sidebar = document.getElementById("sidebar").clientWidth;
      if (sidebar == 80) {
        this.hideClassName = "hide-item";
        return;
      }
      this.hideClassName = "show-item";
    },
    isMenuVisible(route) {
      if (this.userLogged.roles.includes("ADMIN")) return true;
      const item = this.menus.find((item) => item.key == route);
      if (!item) return true;
      if (item.roles.length <= 0) return true;
      if (!this.userLogged.rolesMenu) {
        return false;
      }
      return item.roles.some((elemento) =>
        this.userLogged.rolesMenu.includes(elemento)
      );
    },
    getMenus() {
      this.$store.dispatch("roles/getMenus");
    },
  },
  mounted() {
    if (process.env.NODE_ENV === "production") {
      this.colorBackground = "black";
    } else this.colorBackground = "purple";
    this.$sidebar.ocultarSideBar();
    this.initScrollbar();
    this.resizeObserver = new ResizeObserver(this.onResize);
    let sidebar = document.getElementById("sidebar");
    this.resizeObserver.observe(sidebar);
    this.userLogged = JSON.parse(localStorage.getItem("user"));
    this.getMenus();
  },
  beforeUnmount() {
    let sidebar = document.getElementById("sidebar");
    this.resizeObserver.unobserve(sidebar);
  },
  watch: {
    menusStatus(val) {
      if (val.loaded) {
        this.menus = this.$store.state.roles.menus.data.cliente;
      }
    },
  },
};
</script>
